// extracted by mini-css-extract-plugin
module.exports = {"QuesBlock":"CheckoutSummary_QuesBlock__NExL5","Correct":"CheckoutSummary_Correct__1cAtx","Wrong":"CheckoutSummary_Wrong__31NgD"};